module.exports = __webpack_public_path__ + "img/icons8-viber.f71a5e82.svg";